import React from 'react';
import photo1 from './images/3.jpg';
const AboutUs = () => {
  return (
    <div className="container my-5">
      <div className="text-center mb-4">
        <h2 className="fw-bold">About PharmaCart</h2>
        <p className="text-muted">
          Trusted online pharmacy delivering wellness and care to your doorstep.
        </p>
      </div>

      {/* Mission Section */}
      <div className="row align-items-center mb-5">
        <div className="col-md-6">
          <img
            src={photo1}
            alt="Mission"
            className="img-fluid rounded shadow"
          />
        </div>
        <div className="col-md-6">
          <h4 className="fw-bold">Our Mission</h4>
          <p>
            At PharmaCart, we aim to provide safe, affordable, and authentic healthcare products. We simplify access to medicines and wellness essentials through technology and dedication.
          </p>
        </div>
      </div>

      {/* What Makes Us Unique */}
      <div className="mb-5">
        <h4 className="fw-bold text-center mb-4">Why Choose Us</h4>
        <div className="row text-center">
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title">Genuine Medicines</h5>
                <p className="card-text">All our products are sourced from certified vendors and verified by licensed pharmacists.</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title">Fast Delivery</h5>
                <p className="card-text">Get medicines and healthcare essentials delivered to your door in no time.</p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body">
                <h5 className="card-title">24/7 Support</h5>
                <p className="card-text">Our dedicated team is available round-the-clock to assist you with your health needs.</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Final Callout */}
      <div className="bg-success text-white text-center py-4 rounded shadow-sm">
        <h5>Ready to experience pharmacy at your fingertips?</h5>
        <a href="/medicines" className="btn btn-light mt-2 px-4">Explore Our Products</a>
      </div>
    </div>
  );
};

export default AboutUs;
